module.exports = __webpack_public_path__ + "media/svg/gt-a208122c.svg";